import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'
import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/MAN.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'

import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/newlogoharmankid._optimized.svg'


import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'
import { useAuth } from 'store/client/authStore'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma

import { ReactComponent as ZaraFscrr } from '../../../../../assets/waist/fscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/waist/fsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/waist/fsctmpaper.svg'
import { ReactComponent as NewPriceLabel } from '../../../../../assets/newpriceanahat_optimized.svg'
import { ReactComponent as ZaraLogoNewFullfill } from '../../../../../assets/zarahome/fscfullfilnew.svg'

import { ReactComponent as LeftNewQrSiders } from '../../../../../assets/leftnewqrsiders_optimized.svg'
import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextLeftt from './DynamicShrinkLefft'
import RenderIndoItems from './RenderIndoItems'
import requests from 'service/api'
import { padZaraColorCode } from 'lib/zaraOrderImport'
import { isNewPriceLabelSizeRow } from 'lib/zaraArtworkSizes'

/* ============================================================================
 * NEW ZARA — US/UK fiyat satırı (SVG'siz, tamamen HTML/text).
 * Eski akışta "US $ ... / UK £ ... / market only" yazıları usuk.svg gibi
 * SVG arkaplanların içindeydi; yeni Zara datasında bunlar elle yazılır.
 * Fontlar: LT Pro 75 Bold (US/UK), LT Std Bold (sembol+fiyat), LT Pro 45 Light (alt yazı).
 * Page2Kids da bu component'i import eder — tek kaynak.
 * ========================================================================== */
export function PriceRow({ market, currency, integer, decimal, description, southAmerica }) {
  if (!integer && !decimal) return null

  return (
    <div style={{ display: 'grid',   justifyContent:"center",alignItems:"center",paddingLeft:2 }}>
      {/* Üst fiyat satırı: US $ 69[90] — baseline hizalı */}
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          whiteSpace: 'nowrap',


        }}
      >
        {/* South America (Brasil): market etiketi YOK — sadece "R$ 85" bitişik.
         * Normal: "US" etiketi + boşluklu "$" sembolü. */}
        {!southAmerica && (
          <span
            className="helve-pro-bold"
            style={{ fontSize: '7pt', margin: 0, lineHeight: 1, marginRight: '2pt' }}
          >
            {market}
          </span>
        )}
        <span
          className="helve-bold"
          style={{
            fontSize: '12pt',
            margin: 0,
            lineHeight: 1,
            marginRight: southAmerica ? '4pt' : '4pt'
          }}
        >
          {currency}
        </span>
        <span
          className="helve-bold"
          style={{ fontSize: '15pt', margin: 0, lineHeight: 1 }}
        >
          {integer}
        </span>
        {/* Decimal — integer'ın sağ ÜSTÜNDE (superscript). Gereksiz boşluk olmasın. */}
        <span
          className="helve-bold"
          style={{
            fontSize: '8.745pt',
            margin: 0,
            lineHeight: 1,
            position: 'relative',
            top: '-5pt',
            left: 0
          }}
        >
          {decimal}
        </span>
      </div>
      {/* Alt açıklama — South America: "Exclusivo para Brasil", normal: "US market only" */}
      <span
        className="helve-pro-light"
        style={{ fontSize: '5.5pt', margin: 0, lineHeight: 1.06, whiteSpace: 'nowrap',textAlign:"center" }}
      >
        {description}
      </span>
    </div>
  )
}


export default function Page1({
  sizeData,
  selectColor = 0,
  barcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  // PriceKnife (bıçak izi) modundan render edildiğinde true —
  // harman logo ve referans SVG blokları gizlenir (knifes'ta istenmez).
  bicakIzi = false

}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  // Bölmek için "/" karakterini kullan
  const selectedFscType = data.company?.fsctype;

  const [brand, category, subCategory] = department.split(' / ')
  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const FSC_COMPONENTS = {
    fscrr: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctm: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctmpaper: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
  };
  const FSC_POSITIONS = {
    fscrr: { bottom: 27.5, left: 36.80, fontsize: "2.96px", fontweight: "normal" },
    fsctm: { bottom: 27, left: 38.80, fontsize: "2.96px", fontweight: "normal" },
    fsctmpaper: { bottom: 26.702, left: 39.30, fontsize: "3.59px", fontweight: 900 },
  };
  
  const SelectedComponent = FSC_COMPONENTS[selectedFscType];
  const position = FSC_POSITIONS[selectedFscType] || { 
    bottom: 27.5, 
    left: 36.80, 
    fontsize: "2.96px", 
    fontweight: "normal" 
  }; //
  useEffect(() => {
    if (subCategory) {
      setCurrentShape(subCategory)
    }
  }, [subCategory])

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };

  useEffect(() => {

    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak


  useEffect(() => {
    if (subCategory) {
      if (category === 'Woman') {
        if (subCategory === 'WOMAN') {
          settopValue(16);
          setleftValue(97.9)
      
        } else if (subCategory === 'PREMIUM DENIM') {
          settopValue(16);
          setleftValue(97.9)
       
        } else if (subCategory === 'CIRCULAR WOMAN') {
          settopValue(16);
          setleftValue(97.9)
      
        } else if (subCategory === 'BASIC') {
            settopValue(18);
         setleftValue(99.8)
     
        } else if (subCategory === 'TRF') {
           settopValue(16);
          setleftValue(92.4)
        } else {
  
        }
      } else if (category === 'Man') {
        if (subCategory === 'DENIMWEAR') {
            settopValue(16);
          setleftValue(92.4)
        } else if (subCategory === 'MAN') {
              settopValue(18);
          setleftValue(99.8)
        } else if (subCategory === 'GLOBAL') {
          settopValue(16);
          setleftValue(98)
      
        } else {
      
        }
      } else if (category === 'Kids') {
        if (subCategory === 'GIRL') {
          settopValue(16);
          setleftValue(97.9)
        } else if (subCategory === 'KIDS A (BABY GIRL)') {
           settopValue(16);
          setleftValue(97.9)
        } else if (subCategory === 'BABY UNIQUE' || subCategory === 'KNIT' || subCategory === 'DENIM' || subCategory === 'OUTERWEAR') {
          settopValue(7);
          setleftValue(90.5)
        } else if (subCategory === 'BOY') {
          settopValue(18);
          setleftValue(99.8)
       
        } else if (subCategory === 'KIDS O (BABY BOY)') {
          settopValue(18.1);
          setleftValue(99.6)
        } else {
  
        }
      } else {
   
      }
        
    }
  }, [subCategory]);

  const renderSVG = (integer3, decimal3, integer4, decimal4) => {

    // Değerleri stringe çevirip kontrol ediyoruz
    const isInteger3Valid = String(integer3).trim() !== '';
    const isDecimal3Valid = String(decimal3).trim() !== '';
    const isInteger4Valid = String(integer4).trim() !== '';
    const isDecimal4Valid = String(decimal4).trim() !== '';
  if(SouthAmerica)
  {
    return <MySVG2900 width="23.256mm" height="14.496mm" />;
    

  }
  else{
    switch (true) {
      case isInteger3Valid && isDecimal3Valid && isInteger4Valid && isDecimal4Valid:
        return <MySVG20 width="21.256mm" height="14.496mm" />;
      case isInteger3Valid && isDecimal3Valid && !isInteger4Valid :
        return <MySVG249 width="21.256mm" height="14.496mm" />;
      case isInteger4Valid && isDecimal4Valid && !isInteger3Valid:
        return <MySVG250 width="21.256mm" height="14.496mm" />;
      default:
        return null; // Hiçbir koşul sağlanmazsa hiçbir şey döndürme
    }
  }
  

  };
 /* 
  <div style={{position:"absolute",left:12,top:-2}}>
  <MySVGTry style={{width:"55.2mm",height:"110.2mm"}}/>

  </div>
  */
  const renderShape = (currentShape, category) => {
    if (category === 'Woman') {
      switch (currentShape) {
        case 'WOMAN':
          return (
            <MySVG11 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}
          />
          )
        case 'PREMIUM DENIM':
      

          return (
            <MySVG11 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}

          />
          )

        case 'BASIC':
    
          return (
            <MySVG10 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )
        case 'TRF':
          return (
            <MySVG12 
            style={{
              width: '12.4mm',
              height: '10.4mm',
            }}
          />
          )
        default:
          return (
            <></>
          )
      }
    } else if (category === 'Man') {
      switch (currentShape) {
        case 'DENIMWEAR':
          return (
            <MySVG9 
            style={{
              width: '12.4mm',
              height: '10.4mm',
            }}
          />
          )

        case 'MAN':
          return (
            <MySVG7 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )

        case 'GLOBAL':
          return (
            <MySVG8 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}
          />
          )

        default:
          return (
            <></>
          )
      }
    } else if (category === 'Kids') {
      switch (currentShape) {
        case 'GIRL':
          return (
            <MySVG16 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}
          />
          )

        case 'KIDS A (BABY GIRL)':
          return (
            <MySVG14 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}
          />
          )

        case 'BABY UNIQUE':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'KNIT':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'DENIM':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'OUTERWEAR':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'BOY':
          return (
            <MySVG15 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )

        case 'KIDS O (BABY BOY)':
          return (
            <MySVG13 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )

        default:
          return (
            <></>
          )
      }
    } else {
      // Eğer kategori ve alt kategori eşleşmiyorsa varsayılan bir şekil döndür
      return (
        <></>
      )
    }
  }

  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])

  

  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  let shape

  /* ============================================================================
   * NEW ZARA PRICE LABEL — DATA ACCESS TEST (NORMAL ZARA, YETİŞKİN BEDEN)
   * Bu blok SADECE test amaçlıdır: okuma + console.log + cache QR fetch.
   * Legacy order (newPriceLabel == null) hiçbir şekilde etkilenmez.
   * Tasarım/layout/CSS değişikliği YOK; eski QR generator KULLANILMIYOR.
   * ========================================================================== */
  const newPriceLabel = data?.newPriceLabel
  const hasNewZaraData = newPriceLabel?.schemaVersion >= 1

  // Cache'ten getirilen GERÇEK Zara QR SVG içeriği (inline render — vektör)
  const [cachedQrSvg, setCachedQrSvg] = useState(null)

  function splitMinorAmount(amountMinor) {
    const value = Number(amountMinor)
    if (!Number.isFinite(value)) return { major: null, minor: null }
    return {
      major: String(Math.floor(value / 100)),
      minor: String(value % 100).padStart(2, '0')
    }
  }

  // --- currentVariant / currentSize çözümleme (yeni datayı kullan) ---
  let currentVariant = null
  let currentSize = null

  if (hasNewZaraData) {
    const currentColorCode = data?.priceLabel?.[selectColor]?.colorCode
    currentVariant =
      (newPriceLabel.variants || []).find(
        (v) => String(v.colorCode) === String(currentColorCode)
      ) || null

    // Parent newPriceLabel.sizes satırını doğrudan veriyorsa eşleştirmeye gerek yok
    // (katalog priceLabel çift satır → çift kart sorununu çözer).
    if (isNewPriceLabelSizeRow(sizeData)) {
      currentSize = sizeData
    } else if (currentVariant) {
      // Legacy sizeData (sCode/name) → JSON size eşlemesi (geriye uyum)
      const legacySizeKey = String(sizeData?.sCode ?? sizeData?.name ?? '').trim()
      const normKey = (v) => {
        const s = String(v ?? '').trim()
        return /^\d+$/.test(s) ? String(parseInt(s, 10)) : s
      }
      currentSize =
        (currentVariant.sizes || []).find(
          (s) =>
            String(s.size).trim() === legacySizeKey ||
            normKey(s.size) === normKey(legacySizeKey) ||
            (s.age != null && String(s.age).trim() === legacySizeKey) ||
            (s.code != null &&
              (String(s.code).trim() === legacySizeKey ||
                normKey(s.code) === normKey(legacySizeKey)))
        ) || null
    }
  }


  const article = newPriceLabel?.article
  const prices = newPriceLabel?.prices

  const usaParts = splitMinorAmount(prices?.usa?.amountMinor)
  const ukParts = splitMinorAmount(prices?.uk?.amountMinor)
  const brParts = splitMinorAmount(prices?.br?.amountMinor)

  /*
   * Görünen beden (display size): JSON beden anahtarı ham olabilir ("1").
   * Etikette basılacak karşılık coğrafi map'ten gelir ("1" → "XS").
   * Öncelik: EUR → USA → UK (harf bedenli serilerde hepsi aynı; rakam
   * serilerde EUR katalog değeridir). Seride karşılığı yoksa ham anahtar.
   */
  const displaySize =
    currentSize?.geographic?.EUR ||
    currentSize?.geographic?.USA ||
    currentSize?.geographic?.UK ||
    currentSize?.size ||
    null

  // KADIN ALT - RAKAMLI: ana beden + USA / MEX / UK / IT dönüşüm satırı
  // (JSON SIZE_GEOGRAPHIC_*). Diğer beden tablolarında sadece MEX|BR kalır.
  const sizeGroupName = String(
    szrgrp?.name || data?.sizeGroup?.name || ''
  ).toUpperCase()
  const isKadinAltRakamli =
    sizeGroupName.includes('KADIN ALT') && sizeGroupName.includes('RAKAMLI')

  /*
   * NEW ZARA product line — PARÇALI render (tek string değil):
   * Her parça ayrı span; çünkü bold/normal font karışık.
   *  - Normal (0, /, productRef): Helvetica Neue LT Std 55 Roman (helve-roman)
   *  - Bold   (model, quality, colorCode, size): Helvetica Neue LT Std 75 Bold (helve-bold)
   *  - İkisi de 6.9997pt.
   * productLine string'i yalnızca debug logları için parts'tan türetilir.
   */
  const productLineParts =
    hasNewZaraData && article
      ? [
          { text: '0', bold: false },
          { text: article.model, bold: true },
          { text: article.quality, bold: true },
          { text: padZaraColorCode(currentVariant?.colorCode), bold: true },
          // SIZE_CODE değerini kullan ("2" → "02"); yoksa displaySize'a düş
          { text: currentSize?.code ?? displaySize, bold: false },
          ...(article.productRef
            ? [
                { text: '/', bold: false },
                { text: article.productRef, bold: true }
              ]
            : [])
        ].filter((p) => p.text)
      : []

  const productLine =
    productLineParts.length > 0
      ? productLineParts.map((p) => p.text).join(' ')
      : null

  if (hasNewZaraData) {
    console.log('NEW ZARA - MAIN SIZE:', currentSize?.size)
    console.log('NEW ZARA - MEX:', currentSize?.geographic?.MEX)
    console.log('NEW ZARA - SIZE SERIE:', article?.sizeSerie)
    console.log('NEW ZARA - ACTIVE SIZE:', currentSize?.size)
    console.log('NEW ZARA - PRODUCT LINE:', productLine)
    console.log('NEW ZARA - USA:', {
      symbol: prices?.usa?.symbol,
      amountMinor: prices?.usa?.amountMinor,
      ...usaParts
    })
    console.log('NEW ZARA - UK:', {
      symbol: prices?.uk?.symbol,
      amountMinor: prices?.uk?.amountMinor,
      ...ukParts
    })
    console.log('NEW ZARA - QR:', {
      size: currentSize?.size,
      payload: currentSize?.qr?.payload,
      originalUrl: currentSize?.qr?.originalUrl,
      cacheKey: currentSize?.qr?.cacheKey,
      localPath: currentSize?.qr?.localPath,
      cacheStatus: currentSize?.qr?.cacheStatus
    })

    const newZaraDebug = {
      size: currentSize?.size ?? null,
      mex: currentSize?.geographic?.MEX ?? null,
      sizeSerie: article?.sizeSerie ?? [],
      productLine,
      usa: {
        symbol: prices?.usa?.symbol ?? null,
        amountMinor: prices?.usa?.amountMinor ?? null,
        ...usaParts
      },
      uk: {
        symbol: prices?.uk?.symbol ?? null,
        amountMinor: prices?.uk?.amountMinor ?? null,
        ...ukParts
      },
      qr: {
        payload: currentSize?.qr?.payload ?? null,
        originalUrl: currentSize?.qr?.originalUrl ?? null,
        cacheKey: currentSize?.qr?.cacheKey ?? null,
        localPath: currentSize?.qr?.localPath ?? null,
        cacheStatus: currentSize?.qr?.cacheStatus ?? null
      }
    }
    console.log(`[NEW ZARA PRICE LABEL][SIZE ${currentSize?.size}]`, newZaraDebug)
  }

  // --- Backend cache'teki GERÇEK Zara QR SVG'sini getir (inline vektör render) ---
  useEffect(() => {
    if (!hasNewZaraData) return undefined
    if (currentSize?.qr?.cacheStatus !== 'cached' || !currentSize?.qr?.cacheKey)
      return undefined

    let cancelled = false

    requests.zaraPriceLabel
      .getQr(currentSize.qr.cacheKey)
      .then(async (response) => {
        if (cancelled) return
        // SVG'yi METİN olarak oku — <img> DEĞİL inline SVG render edeceğiz.
        // Blob URL + <img> kullanılsaydı etiket dışa aktarılırken (PNG/SVG export)
        // rasterlaşma riski olurdu; inline SVG vektör kalır.
        const blob =
          response.data instanceof Blob
            ? response.data
            : new Blob([response.data], { type: 'image/svg+xml' })
        const rawText = await blob.text()
        if (cancelled) return

        // SVG boyutunu normalize et: inline gömülen SVG kendi width/height
        // attribute'una göre render olur ve konteynere uymayabilir.
        // viewBox yoksa orijinal boyutlardan üret, width/height'u %100 yap →
        // 67x67 konteynere aynen oturur, vektör kaybı OLMAZ.
        let svgText = rawText
        try {
          const doc = new DOMParser().parseFromString(rawText, 'image/svg+xml')
          const svg = doc.documentElement
          if (svg && svg.tagName.toLowerCase() === 'svg') {
            if (!svg.getAttribute('viewBox')) {
              const w = parseFloat(svg.getAttribute('width')) || 67
              const h = parseFloat(svg.getAttribute('height')) || 67
              svg.setAttribute('viewBox', `0 0 ${w} ${h}`)
            }
            svg.setAttribute('width', '100%')
            svg.setAttribute('height', '100%')
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet')
            svgText = new XMLSerializer().serializeToString(svg)
          }
        } catch (parseErr) {
          console.warn('[NEW ZARA PRICE LABEL] QR SVG parse/normalize atlandı:', parseErr)
          svgText = rawText
        }

        setCachedQrSvg(svgText)
        console.log(
          `[NEW ZARA PRICE LABEL][SIZE ${currentSize?.size}] QR SVG cache'ten getirildi:`,
          {
            endpoint: `/zara-price-label/qr/${currentSize.qr.cacheKey}`,
            svgLength: svgText.length,
            contentType: response.headers?.['content-type']
          }
        )
      })
      .catch((e) => {
        console.warn(
          `[NEW ZARA PRICE LABEL][SIZE ${currentSize?.size}] QR SVG getirilemedi:`,
          e?.response?.status || e?.message
        )
      })

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNewZaraData, currentSize?.qr?.cacheKey, currentSize?.qr?.cacheStatus])



  return (
    <div>
      <div>
        <div>

          <div
            style={{
              position: 'absolute',
              top: -5,
              left: 8.2,

              justifyContent: 'center',
              display: 'grid',
              alignItems: 'center',
              textAlign: 'center'
            }}
          >
            {rifd && (
                <ALARM width="20.4mm" height="20.1mm" />
            )}
          </div>
          <div style={{


position: 'absolute',
top: '23px',
left: '108.5px',
zIndex:4
}}>
<ZaraBomRed width="4.4mm" height="4.4mm"></ZaraBomRed>
</div>
          {!bicakIzi && (
          <div
            style={{
              position: 'absolute',
              top: topValue-4,
              left: leftValue+0.7,
              display: 'flex', // Flexbox kullanımı
    justifyContent: 'center', // Yatayda ortalama
    alignItems: 'center', // Dikeyde ortalama
            }}
          >

    

{renderShape(currentShape, category)}

          </div>
          )}
          <div></div>
       

   <div
            style={{
              position: 'absolute',
              top: SouthAmerica ? 276 : 263.4, // SouthAmerica true ise 270, değilse 288.6
              left: SouthAmerica ?15.6:12,
              flexDirection: 'column',
              display: 'grid',

              width:"94.7%",
            }}
          >
  {/* NEW ZARA: US/UK fiyat bloğu — SVG DEĞİL, tamamen HTML text.
   * Eski akışta "US $ / UK £ / market only" yazıları SVG arkaplanın içindeydi
   * (usuk.svg, justus.svg, justuk.svg, RDOLAR.svg); yeni Zara datasında elle yazılır.
   * Legacy order'da (newPriceLabel yok) eski renderSVG yolu aynen korunur. */}
  {hasNewZaraData ? (
    <div style={{ display: 'grid', rowGap: '3pt' }}>
      {SouthAmerica ? (
        /* SOUTH AMERICA: TEK kart — US'in yerine R$ fiyatı basılır,
         * market etiketi yok, "Exclusivo para Brasil" yazar, UK KARTI YOK. */
        <PriceRow
        market="BR"
        currency={prices?.br?.symbol || 'R$'}
        integer={brParts.major}
        decimal={brParts.minor}
        description="Exclusivo para Brasil"
        southAmerica
      />
    ) : (
      <>
        <PriceRow
          market="US"
          currency={prices?.usa?.symbol || currencysymbol3}
          integer={usaParts.major}
          decimal={usaParts.minor}
          description="US market only"
        />
        <div style={{marginTop:1.1}}>
        <PriceRow
          market="UK"
          currency={prices?.uk?.symbol || currencysymbol4}
          integer={ukParts.major}
          decimal={ukParts.minor}
          description="UK market only"
        />
        </div>
        </>
      )}
    </div>
  ) : (
    renderSVG(integerpart3, decimalpart3, integerpart4, decimalpart4)
  )}
          </div>

          {/* Legacy sayı bloğu — integerpart3/4 prop'larından.
           * NEW ZARA datası varsa fiyatlar yukarıdaki PriceRow'da basıldığı için
           * bu blok atlanır (çift yazımı önler). Legacy order'da aynen çalışır. */}
          {!hasNewZaraData && (
          <div
            style={{
              position: 'absolute',
              top:  integerpart3 === '' ? 310 : 282.6, // Koşullu top değeri
              left: 119,
              flexDirection: 'column',
              display: 'grid'
            }}
          >
     
            <div style={{ display: 'grid',marginTop:SouthAmerica?4:0,marginLeft:SouthAmerica?2:0 }}>
              <div style={{ display: 'grid' }}>
                {integerpart3 && (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
               
                      <p className="helve-medium" style={{ fontSize: '14pt' }}>
                        {integerpart3}
                      </p>
                      <p
                        className="helve-medium"
                        style={{ fontSize: '9pt', marginTop:0, marginRight: '4px' }}
                      >
                        {decimalpart3}
                      </p>
                    </div>
                    <div>
              
                    </div>
                  </>
                )}
              </div>
            </div>
            <div style={{ display: 'grid', marginTop: 4 }}>
            {integerpart4 && !SouthAmerica && (
                <>
  

                  <div style={{ display: 'flex', flexDirection: 'row' }}>
               
                    <p className="helve-medium" style={{ fontSize: '14pt' }}>
                      {integerpart4}
                    </p>
                    <p
                      className="helve-medium"
                      style={{ fontSize: '9pt', marginTop: 0, marginRight: '4px' }}
                    >
                      {decimalpart4}
                    </p>
                  </div>
                  <div>
              
                  </div>
                </>
              )}
            </div>
          </div>
          )}



    {!bicakIzi && (
    <div style={{ position: 'absolute', bottom:32.4, left: 57.6 }}>

          <MyLogoHarman width="39.258mm " height="7.883mm" />
          </div>
    )}
   {!bicakIzi && (
   <div style={{ position: 'absolute', bottom: 32.7, left: 28.6 }}>
          {SelectedComponent && (
  <SelectedComponent.component
    width={SelectedComponent.width}
    height={SelectedComponent.height}
  />
)}
</div>
   )}
<div style={{position:"absolute",top:116.8,left:49,width:"135px",height:"0.5px",backgroundColor:"#1d1f1c"}}>

            </div>
<div
  style={{
    position: 'absolute',
    bottom: position.bottom,
    left: position.left,
    letterSpacing: "0.15px"
  }}
>          <span className='helve-roman' style={{fontSize:position.fontsize,color:"#1d1d1b",fontWeight:position.fontWeight}}>
          {data.company?.fsc}
          </span>
          </div>

     
 

      
    
       

          <div style={{ position: 'absolute', top: 96.9, left: 11,width:"95.5%"}}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
            >

{/*
 * NEW ZARA: beden serisi newPriceLabel.article.sizeSerie'den listelenir,
 * boyanacak beden currentSize.size DEĞER bazlı bulunur,
 * font Helvetica Neue LT Std 65 Medium (helve-medium) 6.276pt.
 * Legacy: mevcut filteredIndo/index bazlı highlight 8pt aynen kalır.
 */}
{hasNewZaraData ? (
  <RenderIndoItems
    indo={(article?.sizeSerie || []).map((s) => ({ name: s }))}
    /* Şerit üyeleri SIZE_SERIE'den ("XS,S,M..."); aktif beden displaySize —
     * ham size ("1") seride olmadığından highlight düşer, coğrafi karşılık
     * ("XS") serinin üyesidir ve doğru kutuyu boyar. */
    highlightValue={displaySize}
    fontSize="6.276pt"
  />
) : (
  <RenderIndoItems indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />
)}


            </div>
          </div>


          {hasNewZaraData && (
  <div style={{ position: 'absolute', top: 144.9, left: 96, width: 65.5, height: 65.5 }}>
    {cachedQrSvg ? (
      /* INLINE SVG — vektör olarak render edilir, <img> GİBİ rasterlaşmaz.
       * dangerouslySetInnerHTML, bu dosyada modifiedSvgText için kullanılan
       * pattern'ın aynısı. SVG içeriği backend cache'inden (Zara originalliği korunmuş)
       * gelir; DOM'a doğrudan gömülür. */
      <div
        style={{ width: '100%', height: '100%' }}
        dangerouslySetInnerHTML={{ __html: cachedQrSvg }}
      />
    ) : (
      <span style={{ fontSize: 8, color: '#999' }}>
        {currentSize?.qr?.cacheStatus === 'cached'
          ? 'QR yükleniyor...'
          : `cacheStatus: ${currentSize?.qr?.cacheStatus ?? 'yok'}`}
      </span>
    )}
  </div>
)}
{hasNewZaraData && (
            <span
              className="helve-pro-roman"
              style={{
                position: 'absolute',
                top: 146.2,
                left: 173.4,
                fontSize: '5.9999pt',
                transform: 'rotate(90deg)',
                transformOrigin: 'left top',
                letterSpacing: '0.9px'
              }}
            >
              www.zara.com
            </span>
          )}

{hasNewZaraData && (
       <span
       className="helve-roman"
       style={{
         position: 'absolute',
         top: 52.37,
         left: 13,
         fontSize: '5pt',
         width: "94.2%",
         color: '#b2b2b2',
         letterSpacing:0.09,
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',

       }}
     >
       <span style={{letterSpacing:0.09,transform: 'translateX(0.7px)'}}>Talla</span>
       <span style={{letterSpacing:0.09,marginLeft:1.9,marginRight:1.7,transform: 'translateX(0.7px)'}} >/</span>
       <span style={{transform: 'translateX(0.7px)'}}>Size</span>
       <span style={{letterSpacing:0.09,marginLeft:1.7,marginRight:2,transform: 'translateX(0.7px)'}} >/</span>
       {/* South America (Brasil): "Taille" yerine "Tamanho" */}
       <span style={{transform: 'translateX(0.7px)'}}>{SouthAmerica ? 'Tamanho' : 'Taille'}</span>
  
     </span>
          )}

{hasNewZaraData && (
            <div style={{ position: 'absolute', top: 146.57, left:63.4 }}>
              <LeftNewQrSiders width="6.049mm" height="auto" />
            </div>
          )}

          {hasNewZaraData && (
       <div 
       style={{ 
         position: 'absolute', 
         top: 66.8, 
         left: 12, 
         display: 'flex', 
         alignItems: 'baseline', 
         justifyContent: 'center',
         gap: isKadinAltRakamli ? '2.4pt' : '1.91pt',
         width: '94.7%', 
 
       }} 
     >
              <span className="helve-bold" style={{ fontSize: '18pt', lineHeight: 1,paddingRight: isKadinAltRakamli ? 4 : 6.5,transform: 'translateX(2px)' }}>
              {displaySize}
              </span>
              {isKadinAltRakamli ? (
                <>
                  {/* KADIN ALT - RAKAMLI: USA MEX UK IT (JSON geographic) */}
                  <span className="helve-roman" style={{ fontSize: '5pt', lineHeight: 1 }}>USA</span>
                  <span className="helve-bold" style={{ fontSize: '10pt', lineHeight: 1 }}>
                    {currentSize?.geographic?.USA}
                  </span>
                  <span className="helve-roman" style={{ fontSize: '5pt', lineHeight: 1 }}>
                    {SouthAmerica ? 'BR' : 'MEX'}
                  </span>
                  <span className="helve-bold" style={{ fontSize: '10pt', lineHeight: 1 }}>
                    {SouthAmerica ? currentSize?.geographic?.BR : currentSize?.geographic?.MEX}
                  </span>
                  <span className="helve-roman" style={{ fontSize: '5pt', lineHeight: 1 }}>UK</span>
                  <span className="helve-bold" style={{ fontSize: '10pt', lineHeight: 1 }}>
                    {currentSize?.geographic?.UK}
                  </span>
                  <span className="helve-roman" style={{ fontSize: '5pt', lineHeight: 1 }}>IT</span>
                  <span className="helve-bold" style={{ fontSize: '10pt', lineHeight: 1 }}>
                    {currentSize?.geographic?.IT}
                  </span>
                </>
              ) : (
                <>
                  {/* Diğer tablolar: sadece MEX (ZARA SUR → BR) */}
                  <span className="helve-roman" style={{ fontSize: '5pt', lineHeight: 1,transform: 'translateX(0.3px)'}}>
                    {SouthAmerica ? 'BR' : 'MEX'}
                  </span>
                  <span className="helve-bold" style={{ fontSize: '10pt', lineHeight: 1}}>
                    {SouthAmerica ? currentSize?.geographic?.BR : currentSize?.geographic?.MEX}
                  </span>
                </>
              )}
            </div>
          )}

          {/* NEW ZARA: product line — PARÇALI render (tek string değil).
           * Normal parçalar (0, /, productRef) → helve-roman  = Helvetica Neue LT Std 55 Roman,
           * bold parçalar (model, quality, colorCode, size) → helve-bold   = Helvetica Neue LT Std 75 Bold.
           * Hepsi 6.9997pt; baseline hizalı yan yana. top/left değerini yerleştirince ayarla. */}
          {hasNewZaraData && productLineParts.length > 0 && (
    
            
            
            
            <div
              style={{
                position: 'absolute',
                top: 120,
                left: 15.5,
                display: 'flex',
                alignItems: 'baseline',
                whiteSpace: 'nowrap',
                width: '91.9%',
                justifyContent: 'center',

            
              }}
            >
              {productLineParts.map((p, i) => (
                <span
                  key={i}
                  className={p.bold ? 'helve-bold' : 'helve-roman'}
                  style={{
                    fontSize: '6.9997pt',
                    lineHeight: 1,
                    marginLeft: i === 0 ? 0 : '2.33pt'
                  }}
                >
                  {p.text}
                </span>
              ))}
            </div>
          )}
       

          {/* ============================================================
           * TEST ONLY — NEW ZARA cached QR SVG (gerçek backend cache'ten)
           * Layout bozmaması için absolute + yüksek zIndex + pointer-events yok.
           * Final tasarım DEĞİL; bir sonraki fazda kaldırılacak.
           * ============================================================ */}
      
        </div>
      </div>
    </div>
  )
}
